import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { backendFetch } from "@/lib/backend";

const todayKey = () => new Date().toISOString().split("T")[0];

export const StreakVisitRecorder = () => {
  const { user, isLoaded, isSignedIn } = useUser();

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !user) return;

    const today = todayKey();
    const storageKey = `orizonte:streak-visit:${user.id}:${today}`;
    if (window.localStorage.getItem(storageKey) === "recorded") return;

    window.localStorage.setItem(storageKey, "recorded");

    backendFetch("/streak/visit", {
      method: "POST",
      body: JSON.stringify({ source: "app_visit" }),
      cache: "no-store",
    })
      .then((data) => {
        const payload = data as { streak?: unknown; checkedIn?: boolean };
        window.dispatchEvent(new CustomEvent("orizonte-streak-visit", {
          detail: {
            streak: payload.streak,
            checkedIn: Boolean(payload.checkedIn),
          },
        }));
      })
      .catch(() => {
        window.localStorage.removeItem(storageKey);
      });
  }, [isLoaded, isSignedIn, user]);

  return null;
};
